import { render, staticRenderFns } from "./newFileDialog.vue?vue&type=template&id=390dceba&scoped=true"
import script from "./newFileDialog.vue?vue&type=script&lang=js"
export * from "./newFileDialog.vue?vue&type=script&lang=js"
import style0 from "./newFileDialog.vue?vue&type=style&index=0&id=390dceba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dceba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390dceba')) {
      api.createRecord('390dceba', component.options)
    } else {
      api.reload('390dceba', component.options)
    }
    module.hot.accept("./newFileDialog.vue?vue&type=template&id=390dceba&scoped=true", function () {
      api.rerender('390dceba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/newFileDialog.vue"
export default component.exports